module.exports = __webpack_public_path__ + "static/media/NoContent.3706db04.png";